import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import { TUIChatService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { ref, computed } from "../../../../adapter-vue";
import { isPC, isWeChat, isUniFrameWork } from "../../../../utils/env";
import { TUIGlobal } from "../../../../utils/universal-api/index";
import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import imageIcon from "../../../../assets/icon/image.png";
import imageUniIcon from "../../../../assets/icon/image-uni.png";
import cameraUniIcon from "../../../../assets/icon/camera-uni.png";
import { isEnabledMessageReadReceiptGlobal } from "../../utils/utils";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // 图片源, 仅uniapp版本有效, web版本仅支持从相册中选择图片
    // album: 从相册中选择
    // camera: 使用相机拍摄
    imageSourceType: {
      type: String,
      "default": "album"
    }
  },
  emits: ["close"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var inputRef = ref();
    var _currentConversation = ref();
    var IMAGE_TOOLBAR_SHOW_MAP = {
      web_album: {
        icon: imageIcon,
        title: "图片"
      },
      uni_album: {
        icon: imageUniIcon,
        title: "图片"
      },
      uni_camera: {
        icon: cameraUniIcon,
        title: "拍照"
      }
    };
    TUIStore.watch(StoreName.CONV, {
      currentConversation: function currentConversation(conversation) {
        _currentConversation.value = conversation;
      }
    });
    var imageToolbarForShow = computed(function () {
      if (isUniFrameWork) {
        return props.imageSourceType === "camera" ? IMAGE_TOOLBAR_SHOW_MAP["uni_camera"] : IMAGE_TOOLBAR_SHOW_MAP["uni_album"];
      } else {
        return IMAGE_TOOLBAR_SHOW_MAP["web_album"];
      }
    });
    var onIconClick = function onIconClick() {
      // uniapp 环境 发送图片
      if (isUniFrameWork) {
        // 增加 TUIGlobal.chooseMedia 条件限制，防御 uni 打包其他平台小程序时由于打包问题导致 isWeChat 为 true 出现运行时报错
        if (isWeChat && TUIGlobal !== null && TUIGlobal !== void 0 && TUIGlobal.chooseMedia) {
          // 微信小程序从基础库 2.21.0 开始， wx.chooseImage 停止维护，请使用 uni.chooseMedia 代替
          TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.chooseMedia({
            count: 1,
            mediaType: ["image"],
            sizeType: ["original", "compressed"],
            sourceType: [props.imageSourceType],
            success: function success(res) {
              sendImageMessage(res);
            }
          });
        } else {
          // uniapp h5/app 发送图片
          TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.chooseImage({
            count: 1,
            sourceType: [props.imageSourceType],
            success: function success(res) {
              TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.getImageInfo({
                src: res.tempFilePaths[0],
                success: function success(image) {
                  sendImageMessage(res, image.width, image.height);
                }
              });
            }
          });
        }
      } else {
        var _inputRef$value;
        if ((_inputRef$value = inputRef.value) !== null && _inputRef$value !== void 0 && _inputRef$value.click) {
          inputRef.value.click();
        }
      }
    };
    var sendImageInWeb = function sendImageInWeb(e) {
      var _e$target;
      if ((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 || (_e$target = _e$target.files) === null || _e$target === void 0 ? void 0 : _e$target.length) <= 0) {
        return;
      }
      sendImageMessage(e === null || e === void 0 ? void 0 : e.target);
      e.target.value = "";
    };
    var sendImageMessage = function sendImageMessage(files, width, height) {
      var _currentConversation$, _currentConversation$2, _currentConversation$3;
      if (!files) {
        return;
      }
      var options = {
        to: (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$ = _currentConversation.value) === null || _currentConversation$ === void 0 || (_currentConversation$ = _currentConversation$.groupProfile) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.groupID) || (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$2 = _currentConversation.value) === null || _currentConversation$2 === void 0 || (_currentConversation$2 = _currentConversation$2.userProfile) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.userID),
        conversationType: _currentConversation === null || _currentConversation === void 0 || (_currentConversation$3 = _currentConversation.value) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3.type,
        payload: {
          file: files
        },
        needReadReceipt: isEnabledMessageReadReceiptGlobal()
      };
      // todo: 需要处理uniapp文件没有宽高的变形问题，需要linda看看
      TUIChatService.sendImageMessage(options);
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(ToolbarItemContainer, {
        iconFile: _unref(imageToolbarForShow).icon,
        title: _unref(imageToolbarForShow).title,
        iconWidth: _unref(isUniFrameWork) ? '32px' : '21px',
        iconHeight: _unref(isUniFrameWork) ? '25px' : '18px',
        needDialog: false,
        onOnIconClick: onIconClick
      }, {
        "default": _withCtx(function () {
          return [!_unref(isUniFrameWork) ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            "class": _normalizeClass(['image-upload', !_unref(isPC) && 'image-upload-h5'])
          }, [_createElementVNode("input", {
            title: "图片",
            type: "file",
            "data-type": "image",
            accept: "image/gif,image/jpeg,image/jpg,image/png,image/bmp,image/webp",
            onChange: sendImageInWeb,
            ref_key: "inputRef",
            ref: inputRef
          }, null, 544)], 2)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["iconFile", "title", "iconWidth", "iconHeight"]);
    };
  }
});